import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  PackageIcon, ImageIcon, CurrencyIcon, TruckIcon,
  CheckIcon, AlertIcon, UploadIcon, XIcon, TagIcon,
} from '../../components/Icons';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

export default function PublicarAnuncio() {
  const navigate   = useNavigate();
  const location   = useLocation();
  const params     = new URLSearchParams(location.search);
  const editarId   = params.get('editar');
  const modoEditar = !!editarId;

  const [loading,      setLoading]      = useState(false);
  const [loadingDados, setLoadingDados] = useState(modoEditar);
  const [erro,         setErro]         = useState('');
  const [sucesso,      setSucesso]      = useState('');
  const [categorias,   setCats]         = useState([]);
  const [fotos,        setFotos]        = useState([]);
  const [prevFotos,    setPrevs]        = useState([]);
  const [fotosExist,   setFotosExist]   = useState([]);

  const [titulo,       setTitulo]       = useState('');
  const [descricao,    setDescricao]    = useState('');
  const [categoriaId,  setCatId]        = useState('');
  const [estadoBem,    setEstadoBem]    = useState('excelente');
  const [marca,        setMarca]        = useState('');
  const [tamanho,      setTamanho]      = useState('');
  const [precoDia,     setPrecoDia]     = useState('');
  const [caucao,       setCaucao]       = useState('');
  const [diasMin,      setDiasMin]      = useState('1');
  const [diasMax,      setDiasMax]      = useState('30');
  const [regras,       setRegras]       = useState('');
  const [localizacao,  setLocalizacao]  = useState('');
  const [opcaoEntrega, setOpcaoEntrega] = useState('ambas');
  const [disponivelVenda, setDisponivelVenda] = useState(false);
  const [precoVenda,      setPrecoVenda]      = useState('');

  useEffect(() => {
    fetch(`${BASE}/anuncios/categorias`)
      .then(r => r.json())
      .then(d => { if (d.sucesso) setCats(d.categorias); })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!modoEditar) return;
    setLoadingDados(true);
    fetch(`${BASE}/anuncios/${editarId}`)
      .then(r => r.json())
      .then(d => {
        if (!d.sucesso) throw new Error(d.mensagem || 'Não encontrado');
        const a = d.anuncio;
        setTitulo(a.titulo || '');
        setDescricao(a.descricao || '');
        setCatId(a.categoria_id || '');
        setEstadoBem(a.estado_bem || 'excelente');
        setPrecoDia(a.preco_dia || '');
        setCaucao(a.caucao || '');
        setDiasMin(a.dias_minimos || '1');
        setDiasMax(a.dias_maximos || '30');
        setRegras(a.regras || '');
        setLocalizacao(a.localizacao || '');
        setOpcaoEntrega(a.opcao_entrega || 'ambas');
        setDisponivelVenda(a.disponivel_venda || false);
        setPrecoVenda(a.preco_venda || '');
        setFotosExist(a.fotos || []);
      })
      .catch(e => setErro(e.message))
      .finally(() => setLoadingDados(false));
  }, [editarId]);

  const adicionarFotos = (e) => {
    const files = Array.from(e.target.files);
    const novas = files.slice(0, 8 - fotos.length - fotosExist.length);
    setFotos(prev => [...prev, ...novas]);
    novas.forEach(f => {
      const reader = new FileReader();
      reader.onload = ev => setPrevs(prev => [...prev, ev.target.result]);
      reader.readAsDataURL(f);
    });
  };

  const removerFoto = (i) => {
    setFotos(prev  => prev.filter((_,idx) => idx !== i));
    setPrevs(prev  => prev.filter((_,idx) => idx !== i));
  };

  const removerFotoExist = (i) => {
    setFotosExist(prev => prev.filter((_,idx) => idx !== i));
  };

  const guardar = async () => {
    if (!titulo)   return setErro('Título é obrigatório');
    if (!precoDia && !disponivelVenda) return setErro('Define o preço por dia (aluguer) ou activa a opção de compra');
    if (precoDia && !caucao) return setErro('Caução é obrigatória para o aluguer');
    if (disponivelVenda && !precoVenda) return setErro('Define o preço de venda');
    const totalFotos = fotos.length + fotosExist.length;
    if (totalFotos < 1) return setErro('Adiciona pelo menos 1 foto');

    setLoading(true); setErro('');
    try {
      const fd = new FormData();
      fd.append('titulo',        titulo);
      fd.append('descricao',     `${descricao}${marca?'\nMarca: '+marca:''}${tamanho?'\nTamanho: '+tamanho:''}`);
      fd.append('categoria_id',  categoriaId);
      fd.append('estado_bem',    estadoBem);
      fd.append('preco_dia',     precoDia);
      fd.append('caucao',        caucao);
      fd.append('dias_minimos',  diasMin);
      fd.append('dias_maximos',  diasMax);
      fd.append('regras',        regras);
      fd.append('localizacao',   localizacao);
      fd.append('opcao_entrega', opcaoEntrega);
      fd.append('disponivel_venda', disponivelVenda);
      if (disponivelVenda && precoVenda) fd.append('preco_venda', precoVenda);
      if (modoEditar) fd.append('fotos_existentes', JSON.stringify(fotosExist));
      fotos.forEach(f => fd.append('fotos', f));

      const url    = modoEditar ? `${BASE}/anuncios/${editarId}` : `${BASE}/anuncios`;
      const method = modoEditar ? 'PUT' : 'POST';
      const res    = await fetch(url, {
        method,
        headers: { Authorization: `Bearer ${token()}` },
        body: fd,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.mensagem || 'Erro ao guardar');

      setSucesso(modoEditar ? 'Anúncio actualizado com sucesso!' : 'Anúncio criado! Aguarda aprovação do admin.');
      setTimeout(() => navigate('/fornecedor/anuncios'), 2000);
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  const inp = {
    width:'100%', padding:'9px 12px',
    border:'1px solid var(--border)', borderRadius:'8px',
    fontSize:'13px', color:'var(--text-primary)',
    background:'var(--card)', fontFamily:'inherit', outline:'none',
  };
  const lbl = { fontSize:'12px', fontWeight:'500', color:'var(--text-secondary)', display:'block', marginBottom:'5px' };

  if (loadingDados) return (
    <>
      <div className="topbar"><div><div className="topbar-title">A carregar anúncio...</div></div></div>
      <div className="page-content" style={{textAlign:'center',padding:'60px',color:'var(--text-muted)'}}>A carregar dados do anúncio...</div>
    </>
  );

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">{modoEditar ? 'Editar Anúncio' : 'Publicar Anúncio'}</div>
          <div className="topbar-sub">{modoEditar ? 'Actualiza os detalhes do teu bem' : 'Preenche os detalhes do teu bem'}</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={()=>navigate('/fornecedor/anuncios')}>Cancelar</button>
          <button className="btn btn-primary" onClick={guardar} disabled={loading} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <CheckIcon size={14}/> {loading ? 'A guardar...' : modoEditar ? 'Guardar alterações' : 'Publicar anúncio'}
          </button>
        </div>
      </div>

      <div className="page-content">
        <div style={{maxWidth:'720px'}}>

          {/* Alertas */}
          {erro    && <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'14px',fontSize:'13px',color:'var(--danger)',display:'flex',gap:'8px',alignItems:'center'}}><AlertIcon size={14}/>{erro}</div>}
          {sucesso && <div style={{background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'14px',fontSize:'13px',color:'var(--success)',display:'flex',gap:'8px',alignItems:'center'}}><CheckIcon size={14}/>{sucesso}</div>}

          {/* Informações do bem */}
          <div className="card" style={{marginBottom:'14px'}}>
            <div style={{fontSize:'13px',fontWeight:'600',marginBottom:'16px',paddingBottom:'10px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:'8px'}}>
              <div style={{width:'24px',height:'24px',borderRadius:'6px',background:'var(--orange-light)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <PackageIcon size={13} color='var(--orange)'/>
              </div>
              Informações do bem
            </div>
            <div className="grid-2">
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Título do anúncio *</label>
                <input style={inp} type="text" placeholder="Ex: Vestido de Gala Vermelho, Tamanho M" value={titulo} onChange={e=>setTitulo(e.target.value)} />
              </div>
              <div>
                <label style={lbl}>Categoria *</label>
                <select style={inp} value={categoriaId} onChange={e=>setCatId(e.target.value)}>
                  <option value="">Seleccionar categoria</option>
                  {categorias.map(c => <option key={c.id} value={c.id}>{c.icone} {c.nome}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Estado do bem</label>
                <select style={inp} value={estadoBem} onChange={e=>setEstadoBem(e.target.value)}>
                  <option value="excelente">Excelente (como novo)</option>
                  <option value="muito_bom">Muito bom</option>
                  <option value="bom">Bom (uso normal)</option>
                </select>
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Descrição detalhada *</label>
                <textarea style={{...inp,minHeight:'90px',resize:'vertical'}} placeholder="Descreve o bem em detalhe: características, tamanho, marca, uso adequado, restrições..." value={descricao} onChange={e=>setDescricao(e.target.value)} />
              </div>
              <div>
                <label style={lbl}>Marca / Modelo</label>
                <input style={inp} type="text" placeholder="Ex: Zara, Canon, Yamaha" value={marca} onChange={e=>setMarca(e.target.value)} />
              </div>
              <div>
                <label style={lbl}>Tamanho / Dimensões</label>
                <input style={inp} type="text" placeholder="Ex: M, 42, 60x80cm" value={tamanho} onChange={e=>setTamanho(e.target.value)} />
              </div>
            </div>
          </div>

          {/* Fotos */}
          <div className="card" style={{marginBottom:'14px'}}>
            <div style={{fontSize:'13px',fontWeight:'600',marginBottom:'16px',paddingBottom:'10px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:'8px'}}>
              <div style={{width:'24px',height:'24px',borderRadius:'6px',background:'var(--orange-light)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <ImageIcon size={13} color='var(--orange)'/>
              </div>
              Fotos do bem ({fotos.length + fotosExist.length}/8)
            </div>

            <div style={{display:'flex',gap:'10px',flexWrap:'wrap',marginBottom:'12px'}}>
              {/* Fotos existentes */}
              {fotosExist.map((src,i)=>(
                <div key={`exist-${i}`} style={{width:'80px',height:'80px',borderRadius:'8px',overflow:'hidden',position:'relative',border:'2px solid var(--orange)'}}>
                  <img src={src} alt={`foto ${i+1}`} style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'} />
                  <button onClick={()=>removerFotoExist(i)} style={{position:'absolute',top:2,right:2,width:'18px',height:'18px',background:'var(--danger)',border:'none',borderRadius:'50%',color:'#fff',cursor:'pointer',fontSize:'11px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <XIcon size={10} color='#fff'/>
                  </button>
                </div>
              ))}
              {/* Novas fotos */}
              {prevFotos.map((src,i)=>(
                <div key={`new-${i}`} style={{width:'80px',height:'80px',borderRadius:'8px',overflow:'hidden',position:'relative',border:'1px solid var(--border)'}}>
                  <img src={src} alt={`nova foto ${i+1}`} style={{width:'100%',height:'100%',objectFit:'cover'}} />
                  <button onClick={()=>removerFoto(i)} style={{position:'absolute',top:2,right:2,width:'18px',height:'18px',background:'var(--danger)',border:'none',borderRadius:'50%',color:'#fff',cursor:'pointer',fontSize:'11px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <XIcon size={10} color='#fff'/>
                  </button>
                </div>
              ))}
              {(fotos.length + fotosExist.length) < 8 && (
                <div style={{width:'80px',height:'80px',borderRadius:'8px',border:'2px dashed var(--border)',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',cursor:'pointer',transition:'all 0.15s',gap:'4px'}}
                  onClick={()=>document.getElementById('fotos-upload').click()}
                  onMouseOver={e=>{e.currentTarget.style.borderColor='var(--orange)';e.currentTarget.style.background='var(--orange-light)'}}
                  onMouseOut={e=>{e.currentTarget.style.borderColor='var(--border)';e.currentTarget.style.background='transparent'}}>
                  <UploadIcon size={18} color='var(--text-muted)'/>
                  <span style={{fontSize:'9px',color:'var(--text-muted)'}}>Adicionar</span>
                </div>
              )}
            </div>
            <input id="fotos-upload" type="file" accept="image/*" multiple style={{display:'none'}} onChange={adicionarFotos} />
            <div style={{fontSize:'11px',color:'var(--text-muted)'}}>PNG, JPG até 5MB por foto · Mínimo 1 foto · Máximo 8 fotos</div>
          </div>

          {/* Preço e Caução */}
          <div className="card" style={{marginBottom:'14px'}}>
            <div style={{fontSize:'13px',fontWeight:'600',marginBottom:'16px',paddingBottom:'10px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:'8px'}}>
              <div style={{width:'24px',height:'24px',borderRadius:'6px',background:'var(--orange-light)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <CurrencyIcon size={13} color='var(--orange)'/>
              </div>
              Preço e Caução
            </div>
            <div className="grid-2">
              <div>
                <label style={lbl}>Preço por dia (Kz) *</label>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:'10px',top:'50%',transform:'translateY(-50%)',fontSize:'11px',color:'var(--text-muted)',fontWeight:'600'}}>Kz</span>
                  <input style={{...inp,paddingLeft:'30px'}} type="number" min="0" placeholder="0" value={precoDia} onChange={e=>setPrecoDia(e.target.value)} />
                </div>
              </div>
              <div>
                <label style={lbl}>Caução (Kz) *</label>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:'10px',top:'50%',transform:'translateY(-50%)',fontSize:'11px',color:'var(--text-muted)',fontWeight:'600'}}>Kz</span>
                  <input style={{...inp,paddingLeft:'30px'}} type="number" min="0" placeholder="0" value={caucao} onChange={e=>setCaucao(e.target.value)} />
                </div>
              </div>
              <div>
                <label style={lbl}>Dias mínimos</label>
                <input style={inp} type="number" min="1" value={diasMin} onChange={e=>setDiasMin(e.target.value)} />
              </div>
              <div>
                <label style={lbl}>Dias máximos</label>
                <input style={inp} type="number" min="1" value={diasMax} onChange={e=>setDiasMax(e.target.value)} />
              </div>
              <div style={{gridColumn:'1/-1'}}>
                <label style={lbl}>Regras de uso e devolução</label>
                <textarea style={{...inp,minHeight:'70px',resize:'vertical'}} placeholder="Define as tuas regras: prazo de devolução, condições de uso..." value={regras} onChange={e=>setRegras(e.target.value)} />
              </div>
            </div>
            {precoDia && caucao && (
              <div style={{background:'var(--orange-light)',border:'1px solid #fed7aa',borderRadius:'8px',padding:'10px 14px',marginTop:'12px',fontSize:'12px',color:'var(--orange-dark)'}}>
                Estimativa: {(parseFloat(precoDia)||0).toLocaleString()} Kz/dia · Caução: {(parseFloat(caucao)||0).toLocaleString()} Kz · Taxa KiAluga (10%): {Math.round((parseFloat(precoDia)||0)*0.1).toLocaleString()} Kz
              </div>
            )}
          </div>

          {/* Venda */}
          <div className="card" style={{marginBottom:'14px'}}>
            <div style={{fontSize:'13px',fontWeight:'600',marginBottom:'16px',paddingBottom:'10px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:'8px'}}>
              <div style={{width:'24px',height:'24px',borderRadius:'6px',background:'rgba(22,163,74,0.1)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <TagIcon size={13} color='var(--success)'/>
              </div>
              Opção de Compra
            </div>

            {/* Toggle */}
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'12px',borderRadius:'10px',background:disponivelVenda?'var(--success-bg)':'var(--surface)',border:`1px solid ${disponivelVenda?'var(--success-border)':'var(--border)'}`,marginBottom:disponivelVenda?'14px':'0',cursor:'pointer',transition:'all 0.2s'}}
              onClick={()=>setDisponivelVenda(!disponivelVenda)}>
              <div>
                <div style={{fontSize:'13px',fontWeight:'600',color:disponivelVenda?'var(--success)':'var(--text-primary)'}}>
                  Disponível para compra
                </div>
                <div style={{fontSize:'11px',color:'var(--text-muted)',marginTop:'2px'}}>
                  Permite aos clientes comprar o bem em vez de alugar
                </div>
              </div>
              {/* Toggle switch visual */}
              <div style={{
                width:'42px',height:'24px',borderRadius:'12px',
                background:disponivelVenda?'var(--success)':'var(--border)',
                position:'relative',transition:'background 0.2s',flexShrink:0,
              }}>
                <div style={{
                  position:'absolute',top:'3px',
                  left:disponivelVenda?'21px':'3px',
                  width:'18px',height:'18px',borderRadius:'50%',
                  background:'#fff',transition:'left 0.2s',
                  boxShadow:'0 1px 3px rgba(0,0,0,0.2)',
                }}/>
              </div>
            </div>

            {disponivelVenda && (
              <div>
                <label style={lbl}>Preço de venda (Kz) *</label>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:'10px',top:'50%',transform:'translateY(-50%)',fontSize:'11px',color:'var(--text-muted)',fontWeight:'600'}}>Kz</span>
                  <input style={{...inp,paddingLeft:'30px'}} type="number" min="0" placeholder="0"
                    value={precoVenda} onChange={e=>setPrecoVenda(e.target.value)} />
                </div>
                {precoVenda && (
                  <div style={{background:'rgba(22,163,74,0.08)',border:'1px solid var(--success-border)',borderRadius:'8px',padding:'10px 14px',marginTop:'10px',fontSize:'12px',color:'var(--success)'}}>
                    💰 Preço de venda: {parseFloat(precoVenda||0).toLocaleString()} Kz · Taxa KiAluga (10%): {Math.round(parseFloat(precoVenda||0)*0.1).toLocaleString()} Kz · Recebes: {Math.round(parseFloat(precoVenda||0)*0.9).toLocaleString()} Kz
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Entrega */}
          <div className="card" style={{marginBottom:'20px'}}>
            <div style={{fontSize:'13px',fontWeight:'600',marginBottom:'16px',paddingBottom:'10px',borderBottom:'1px solid var(--border)',display:'flex',alignItems:'center',gap:'8px'}}>
              <div style={{width:'24px',height:'24px',borderRadius:'6px',background:'var(--orange-light)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <TruckIcon size={13} color='var(--orange)'/>
              </div>
              Entrega e Localização
            </div>
            <div className="grid-2">
              <div>
                <label style={lbl}>Opção de entrega</label>
                <select style={inp} value={opcaoEntrega} onChange={e=>setOpcaoEntrega(e.target.value)}>
                  <option value="ambas">Entrega + Levantamento local</option>
                  <option value="entrega">Só entrega ao domicílio</option>
                  <option value="levantamento">Só levantamento local</option>
                </select>
              </div>
              <div>
                <label style={lbl}>Localização do bem</label>
                <input style={inp} type="text" placeholder="Bairro / Município, Luanda" value={localizacao} onChange={e=>setLocalizacao(e.target.value)} />
              </div>
            </div>
          </div>

          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontSize:'11px',color:'var(--text-muted)'}}>
              {modoEditar ? 'As alterações ficam visíveis imediatamente.' : 'O anúncio será revisto pelo admin antes de ficar visível.'}
            </div>
            <div style={{display:'flex',gap:'8px'}}>
              <button className="btn btn-outline" onClick={()=>navigate('/fornecedor/anuncios')}>Cancelar</button>
              <button className="btn btn-primary" onClick={guardar} disabled={loading} style={{display:'flex',alignItems:'center',gap:'6px'}}>
                <CheckIcon size={14}/> {loading ? 'A guardar...' : modoEditar ? 'Guardar alterações' : 'Publicar anúncio'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
